/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressStreet } from '../../models/address-street';

export interface FindStreetAddress$Params {
  classification: number;
  street: string;
}

export function findStreetAddress(http: HttpClient, rootUrl: string, params: FindStreetAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AddressStreet>>> {
  const rb = new RequestBuilder(rootUrl, findStreetAddress.PATH, 'get');
  if (params) {
    rb.path('classification', params.classification, {});
    rb.query('street', params.street, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AddressStreet>>;
    })
  );
}

findStreetAddress.PATH = '/api/post_address/street/{classification}';
